function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 10,
  height: 6,
  x: 24,
  y: 10,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 9,
  height: 5,
  x: 24.5,
  y: 10.5,
  rx: 2.5
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M76.257 86.974H25.08a52.54 52.54 0 00.073-2.761c0-14.593-6.101-27.324-15.153-34.077C16.377 46.862 23.697 45 31.48 45c24.73 0 44.777 18.792 44.777 41.974z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M75.754 86.474C75.468 63.806 55.762 45.5 31.48 45.5c-7.258 0-14.263 1.638-20.543 4.725 9.055 7.138 14.716 19.924 14.716 33.988 0 .756-.016 1.51-.049 2.261h50.15z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M2 6h27v46H2z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M2.5 6.5h26v45h-26z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M27 48h53c-.313 12.196-12.058 22-26.5 22S27.313 60.196 27 48z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M27.52 48.5c.618 11.686 12.02 21 25.98 21s25.362-9.314 25.98-21H27.52z"
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 60,
  height: 7,
  x: 24,
  y: 42,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 59,
  height: 6,
  x: 24.5,
  y: 42.5,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M81.874 43H26.126A4 4 0 0130 38h48a4 4 0 013.874 5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M81.465 42.5a3.5 3.5 0 00-3.465-4H30a3.5 3.5 0 00-3.465 4h54.93z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M31 8H0V3a3 3 0 013-3h25a3 3 0 013 3v5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M30.5 7.5V3A2.5 2.5 0 0028 .5H3A2.5 2.5 0 00.5 3v4.5h30z"
}));

function SvgRoomToilet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 87,
    viewBox: "0 0 84 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomToilet);
export default __webpack_public_path__ + "static/media/RoomToilet.b3c86e0d.svg";
export { ForwardRef as ReactComponent };